import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { DataLineageQuery } from './data-lineage.query';

@Injectable({ providedIn: 'root' })
export class DataLineageAclService extends AbstractFeatureAclService<Y42FeatureType.Lineage> {
  constructor(query: DataLineageQuery) {
    super({
      featureType: Y42FeatureType.Lineage,
      query,
    });
  }
}
